import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { SiteDto } from '../../../dtos/siteDto';
import { skipWhile } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { SitesDataService } from '../data-storage/sites-data.service';
import { GlobalDataService } from '../../../shared-services/global-data.service';
import { SubscriptionPacketDto } from '../../../dtos/subscriptionPacketDto';
import { SubscriptionPacketsService } from '../services/subscription-packets.service';
import { UtilService } from '../../../shared-services/util.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-price-list',
    templateUrl: './price-list.component.html',
    styleUrls: ['./price-list.component.scss']
})
export class PriceListComponent implements OnInit {

    isLoginOpen = false;
    $sites: Observable<SiteDto[]>;
    buyMode = 'single';
    multipleSitesSelected: number[] = [];
    private packetsReceived: SubscriptionPacketDto[] = [];
    groupedDays = [];
    selectedDay;

    constructor(private sitesDataService: SitesDataService, public globalDataService: GlobalDataService,
                private subscriptionPacketsService: SubscriptionPacketsService, private utils: UtilService,
                private router:Router,
                public translate: TranslateService) {
    }

    ngOnInit(): void {
        this.$sites = this.sitesDataService.sites.pipe(
            skipWhile((data: SiteDto[]) => data.length === 0),
            map((data) => data.filter((el) => el.active && !el.free))
        );
    }

    checkBoxChange($event) {
        const siteId = Number($event.target.value);
        if (this.multipleSitesSelected.includes(siteId)) {
            const indexOf = this.multipleSitesSelected.indexOf(siteId);
            this.multipleSitesSelected.splice(indexOf, 1);
        } else {
            this.multipleSitesSelected.push(siteId);
            this.populatePackets(siteId);
        }
    }

    getSite(siteId) {
        return this.sitesDataService.getSiteById(siteId)
    }

    getPacketPrice(siteId) {
        return this.packetsReceived.find((packet: SubscriptionPacketDto) => packet.siteId === siteId && packet.effectiveDays === Number(this.selectedDay));
    }

    getDiscount() {
        return this.subscriptionPacketsService.getDiscount(this.multipleSitesSelected.length);
    }

    getTotalPrice(withDiscount?){
        const arrayPackets: SubscriptionPacketDto[] = [];
        for (let siteId of this.multipleSitesSelected){
            arrayPackets.push(this.getPacketPrice(siteId));
        }
        return this.subscriptionPacketsService.getTotalPrice(arrayPackets, withDiscount);
    }

    changeTab(){
        if(this.buyMode === 'single'){
            this.multipleSitesSelected = [];
        }
    }

    checkComboOwned(){
        let isComboOwned = false;
        for (let siteId of this.multipleSitesSelected){
            const siteDto = this.sitesDataService.getSiteData().find((el:SiteDto)=> el.id === siteId);
            const foundPacket = this.subscriptionPacketsService.isSitePurchased(siteDto);
            if(foundPacket){
                isComboOwned = true;
            }
        }
        return isComboOwned;
    }

    toBuyPage(){
        if(!this.checkComboOwned()){
            const arrayPackets: SubscriptionPacketDto[] = [];
            for (let siteId of this.multipleSitesSelected){
                arrayPackets.push(this.getPacketPrice(siteId));
            }
            sessionStorage.setItem("packetId",arrayPackets.map((packet)=>packet.id).join(','));
            this.router.navigate([this.globalDataService.getRemoteContext()+'/'+this.translate.currentLang+'/buy']);
        }
    }

    private populatePackets(siteId) {
        const foundPacket = this.packetsReceived.find((packet: SubscriptionPacketDto) => packet.siteId === siteId);
        if (!foundPacket) {
            this.subscriptionPacketsService.getSubscriptionPackets(siteId).subscribe((packets) => {
                this.packetsReceived.push(...packets);
                this.createDropDown();
            });
        }
    }

    private createDropDown() {
        const groupByEffectiveDays = this.utils.groupBy(this.packetsReceived, 'effectiveDays');
        this.groupedDays = Object.keys(groupByEffectiveDays);
        if (!this.selectedDay) {
            this.selectedDay = this.groupedDays[0];
        }
    }

}
